/* eslint-disable react/no-danger */
import React from "react";
import { useIntl } from "gatsby-plugin-intl";
import Layout from "components/Layout";
import SEO from "components/SEO";
import PageSection from "components/PageSection";
import BecomeFranchiseeForm from "components/BecomeFranchiseeForm";
import kioskBoothLeftRight from "images/kioskBoothLeftRight.png";
import kioskBoothRightLeft from "images/kioskBoothRightLeft.png";

/* Using default export because it's a page */
export default () => {
  const { formatMessage, locale } = useIntl();

  return (
    <Layout>
      <SEO title={formatMessage({ id: "navigation.open-agency" })} />

      <PageSection startScrollIcon={false}>
        <div className="w-full mt-12">
          <div className="flex flex-col gap-8 items-start w-full min-h-screen lg:flex-row lg:justify-between">
            <div className="flex flex-col  gap-8 w-full ">
              <h2
                className="text-p-title font-semibold px-4 sm:px-8  md:px-14 lg:px-24"
                dangerouslySetInnerHTML={{
                  __html: formatMessage({
                    id: "becomeFranchisee.title",
                  }),
                }}
              />
              <div>
                {/* <div className="px-4 sm:px-8  md:px-14 lg:px-24">
                  <IconedList data={bulletListData} />
                </div> */}
                <img
                  src={
                    locale === "fr" ? kioskBoothLeftRight : kioskBoothRightLeft
                  }
                  alt="kioskBooth"
                  className="w-4/5 sm:w-3/5 md:1/2 lg:w-4/5 "
                />
              </div>
            </div>
            <div className="w-full px-4 sm:px-8  md:px-14 lg:px-24">
              <BecomeFranchiseeForm />
            </div>
          </div>
        </div>
      </PageSection>
    </Layout>
  );
};
